import React, { useState } from 'react';


import { Input, Button, Form, Typography, notification } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';


const { Title, Text } = Typography;



const Signup = (props) => {
  const [adminusername, setAdminusername] = useState('');
  const [adminpassword, setAdminpassword] = useState('');
  const [cnfpassword, setCnfpassword] = useState('');

  const backend_url = process.env.REACT_APP_BACKEND_URL


  const adminsignupsubmit = async (e) => {
    props.setLoad(true);
    try {

      if (adminpassword !== cnfpassword) {
        console.error('password and cnf not match')
        notification.error({
          message: 'Password and Confirm Password not match',
          placement: 'topRight',
          duration: 2,

          icon: <CloseCircleOutlined style={{ color: 'red' }} />,
        });
        return
      }

      const response = await fetch(`${backend_url}/api/admin-signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ adminusername, adminpassword })
      });

      const res = await response.json()
      // console.log(res)


      if (response.status === 201) {
        notification.success({
          message: 'Account created',
          placement: 'topRight',
          duration: 2,

          icon: <CheckCircleOutlined style={{ color: 'green' }} />,
        });
        setAdminusername("");
        setAdminpassword("");
        setCnfpassword("");
        props.onFlip()

      }
      else if (response.status === 409  ) {
        notification.warning({
          message: 'Account already eist',
          placement: 'topRight',
          duration: 2,

          icon: <CheckCircleOutlined style={{ color: 'yellow' }} />,
        });
  
      }
      else {
        notification.error({
          message:`Account not created`,
          placement: 'topRight',
          duration: 2,

          icon: <CloseCircleOutlined style={{ color: 'red' }} />,
        });

      }


    }


    catch (error) {
      // console.error(error);
    }

    finally {
      props.setLoad(false);
    }


  };






  return (

    <>
      <Title level={2} className="text-center mb-6">
        <p className='login-tag'>
          Signup

        </p>
      </Title>
      <Form onFinish={adminsignupsubmit} layout="vertical">
        <Form.Item>
          <Input
            type="text"
            placeholder="Username"
            value={adminusername}
            onChange={(e) => setAdminusername(e.target.value)}
            className="rounded-md md:w-[25vw] w-full"
          />
        </Form.Item>
        <Form.Item>
          <Input.Password
            placeholder="Password"
            value={adminpassword}
            onChange={(e) => setAdminpassword(e.target.value)}
            className="rounded-md"
          />
        </Form.Item>
        <Form.Item>
          <Input.Password
            placeholder="Password"
            value={cnfpassword}
            onChange={(e) => setCnfpassword(e.target.value)}
            className="rounded-md"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="w-full rounded-md">
            Signup
          </Button>
        </Form.Item>
      </Form>

      <Text className="text-black  transition duration-300">
        Already have an account?<span onClick={props.onFlip} className='cursor-pointer font-black' >  Login</span>
      </Text>
    </>

  );
};

export default Signup;
